<template>
    <vue-good-table class="col-12 top-24"
        :columns="columns"
        :rows="this.Partners"
        v-on:row-click="onRowClick"
        :pagination-options="{
            enabled: true,
            perPage: 25
        }"
        :search-options="{
            enabled: true
        }"
    >
        <template #table-actions>
            <download-excel
                class="btn-primary"
                style="padding-top: 1px;
                       padding-bottom: 1px;
                       margin-right: 5px;
                       margin-top: 2px;"   
                :data="this.Partners"

                worksheet="My Worksheet"
                name="filename.xls"
            >
                Экспорт
            </download-excel>
        </template>
    </vue-good-table>
</template>
  
  <script>
    import 'vue-good-table-next/dist/vue-good-table-next.css'
    import { VueGoodTable } from 'vue-good-table-next';
    import JsonExcel from "vue-json-excel3";

  export default {
    components: { VueGoodTable, downloadExcel:JsonExcel, },
    data() {
      return {
        columns: [
            {
                label: 'Название',
                field: 'CompanyName',
            },
            {
                label: 'ИНН',
                field: 'CompanyINN',
                type: 'number',
            },
            {
                label: 'КПП',
                field: 'CompanyKPP',
                type: 'number',
            },
            {
                label: 'ID',
                field: 'CompanyID',
                type: 'number',
            },
        ]
      }
    },
    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
        Partners() {
            return this.$store.state.eco_partners
        },
    },
    methods: {
        onRowClick(params){
            console.log("click", params.row.CompanyINN)
            this.$router.push({ 
                name: 'partner_waste_reports', 
                params: { id: params.row.CompanyINN } 
            });
        }
    }
  };
  </script>
  